import { Download, FileIcon, LockKeyhole } from "lucide-react";
import { fileUrl, zipUrl, fmtBytes } from "@/lib/upload";
import { ExternalLinkRow } from "./ExternalLinkRow";

const TYPE_LABEL = { photos: "Photos", floorplan: "2D Floor Plan", tour: "3D Virtual Tour", video: "Video", link: "External link" };

/** One delivered gallery: its file grid (or thumbnail-less file list) plus
 * the "download all" zip action and any external link row. Returns null
 * when the gallery has nothing to show. */
export function GallerySection({ job, gallery, onOpenFile }) {
  const files = job.files.filter((f) => (f.gallery_id || "main") === gallery.id);
  const imageCount = files.filter((file) => file.is_image).length;
  if (!files.length && !gallery.external_url) return null;
  return (
    <section data-testid={`client-gallery-${gallery.id}`}>
      <div className="flex flex-wrap items-end justify-between gap-4 border-b border-border pb-4">
        <div><div className="eyebrow">{TYPE_LABEL[gallery.type] || gallery.type}</div><h2 className="font-display text-2xl md:text-3xl mt-1">{gallery.name}</h2></div>
        {files.length > 0 && (job.downloads_locked
          ? <span data-testid={`zip-locked-${gallery.id}`} className="inline-flex items-center gap-2 border border-slate-300 h-10 px-4 text-xs text-slate-500"><LockKeyhole className="h-3.5 w-3.5" />Downloads unlock after payment</span>
          : <a href={zipUrl(job.id, gallery.id)} data-testid={`zip-${gallery.id}`} className="btn-outline h-10 px-5"><Download className="h-3.5 w-3.5 mr-2" strokeWidth={1.5} /> Download all ({files.length})</a>)}
      </div>
      {gallery.external_url && <ExternalLinkRow url={gallery.external_url} gid={gallery.id} />}
      {files.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mt-6">
          {files.map((f, index) => (
            <div key={f.id} className="min-w-0">
              <button data-testid={`client-file-${f.id}`} onClick={() => onOpenFile(f)} className="group relative aspect-[4/3] w-full bg-slate-100 overflow-hidden text-left">
                {f.is_image
                  ? <img src={fileUrl(job.id, f.id)} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                  : <div className="h-full flex flex-col items-center justify-center text-slate-500 p-4 text-center"><FileIcon className="h-8 w-8" strokeWidth={1.25} /><span className="text-xs mt-2 truncate w-full">{f.original_filename}</span><span className="text-[10px] text-slate-400 mt-1">{fmtBytes(f.size || 0)}</span></div>}
              </button>
              {f.is_image && <div data-testid={`gallery-photo-ordinal-total-${f.id}`} className="pt-2 text-[10px] font-mono uppercase tracking-[0.12em] text-slate-500">{index + 1}/{imageCount} · {f.original_filename}</div>}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
